var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "featured-collections" }, [
    _c("h1", { staticClass: "featured-collections__title" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _c("p", { staticClass: "featured-collections__body" }, [
      _vm._v(_vm._s(_vm.body))
    ]),
    _c(
      "div",
      { staticClass: "featured-collections__carousel-container" },
      [
        _c(
          "carousel",
          {
            staticClass: "carousel--featured-collections",
            attrs: {
              "slides-to-show": ["mobile", "tablet"].includes(_vm.$mq)
                ? 1.5
                : 4.3,
              arrows: ""
            }
          },
          _vm._l(_vm.collections, function(collection) {
            return _c(
              "slide",
              {
                key: "" + collection.title,
                staticClass: "slide--featured-collections"
              },
              [_c("collection-tile", { attrs: { collection: collection } })],
              1
            )
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }